<script>
  import {
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Icon,
    Badge,
  } from "framework7-svelte";

  export let title = "TRDR Admin";
  export let subtitle = "";
  export let backLink = false;
  export let backLinkUrl = null;
  export let backLinkForce = false;
  export let showMenu = true;
  export let panelId = "#panel-left";
  export let badgeText = "desk.trdr.money";
  export let large = false;
</script>

<Navbar {large} class="admin-standard-navbar">
  <NavLeft slot="left">
    {#if backLink}
      <Link
        back={!backLinkUrl}
        href={backLinkUrl}
        force={backLinkForce}
        iconIos="f7:arrow_left"
        iconAurora="f7:arrow_left"
        iconMd="material:arrow_back"
        text="Back"
      />
    {/if}

    {#if showMenu}
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen={panelId}
        title="Open Navigation Menu"
      />
    {/if}
    <slot name="left" />
  </NavLeft>

  <NavTitle {title} {subtitle} />

  {#if large}
    <NavTitleLarge>{title}</NavTitleLarge>
  {/if}

  <NavRight slot="right">
    <slot name="right-before" />

    {#if badgeText}
      <div class="nav-badge-item">
        <span class="badge-pill">{badgeText}</span>
      </div>
    {/if}

    <slot name="right" />
    <slot />
  </NavRight>
</Navbar>

<style>
  :global(.admin-standard-navbar) {
    --f7-navbar-bg-color: #ffffff;
    --f7-navbar-text-color: #0f172a;
    --f7-navbar-link-color: #0f172a;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .nav-badge-item {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  .badge-pill {
    background: #f1f5f9;
    color: #475569;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    letter-spacing: 0.3px;
  }
</style>
